import { useMemo } from 'react';
import renderSkeletons from './renderSkeltons';
import theme from '@theme';

const SiteInformationsSkeleton: React.FC = () => {
  const skeletonData = useMemo(
    () => [
      { width: 8, height: 8, borderRadius: 2 },
      { width: 138, height: 8, borderRadius: 5, className: 'mx-2' },
      { width: 494, height: 8, borderRadius: 2 },
      { width: 38, height: 22, borderRadius: 4, className: 'd-flex justify-content-end py-2' }
    ],
    []
  );

  return (
    <>
      <div className="d-flex align-items-center">
        {renderSkeletons(
          skeletonData.slice(0, 2).map((s) => ({ ...s, baseColor: theme.palette.grey[200] }))
        )}
      </div>
      {renderSkeletons([{ ...skeletonData[2], baseColor: theme.palette.grey[200] }])}
      <div className={skeletonData[3].className}>
        {renderSkeletons([{ ...skeletonData[3], baseColor: theme.palette.grey[200] }])}
      </div>
    </>
  );
};

export default SiteInformationsSkeleton;
